import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import QuestionMentorFeedback from './question-mentor-feedback';
import QuestionMentorFeedbackDetail from './question-mentor-feedback-detail';
import QuestionMentorFeedbackUpdate from './question-mentor-feedback-update';
import QuestionMentorFeedbackDeleteDialog from './question-mentor-feedback-delete-dialog';

const QuestionMentorFeedbackRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<QuestionMentorFeedback />} />
    <Route path="new" element={<QuestionMentorFeedbackUpdate />} />
    <Route path=":id">
      <Route index element={<QuestionMentorFeedbackDetail />} />
      <Route path="edit" element={<QuestionMentorFeedbackUpdate />} />
      <Route path="delete" element={<QuestionMentorFeedbackDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default QuestionMentorFeedbackRoutes;
